import { functions, auth, fa } from "../../firebase.config";
import router from "../../router";

const state = {
  isSigningIn: false,
  isSigningOut: false,
};

const mutations = {
  SET_SIGNING_IN(state, boolean) {
    state.isSigningIn = boolean;
  },
  SET_SIGNING_OUT(state, boolean) {
    state.isSigningOut = boolean;
  },
};

const actions = {
  signInWithGoogle({ commit, dispatch }) {
    commit("SET_SIGNING_IN", true);
    const provider = new fa.GoogleAuthProvider();

    return auth
      .signInWithPopup(provider)
      .then(function(result) {
        const user = result.user;
        // stop function if not from a redirect
        if (!user) return;
        // continue signing in if there's a user obj
        commit("SET_SIGNING_IN", false);

        const newUser = result.additionalUserInfo.isNewUser;

        if (newUser) return dispatch("createNewUser", user);
        else return dispatch("getData", user);
      })
      .catch(() => {
        let notification = {
          title: "Couldn’t sign you in",
          message: "Please check your wifi and try again",
          type: "error-important",
          icon: "wifi-off",
        };
        dispatch("fireNotification", notification);
        return commit("SET_SIGNING_IN", false);
      });
  },
  signUpWithPassword({ dispatch, commit }, credentials) {
    commit("SET_SIGNING_IN", true);
    return auth
      .createUserWithEmailAndPassword(credentials.email, credentials.password)
      .then(() => {
        const user = auth.currentUser;

        return user.updateProfile({
          displayName: credentials.displayName,
        });
      })
      .then(() => {
        return dispatch("createNewUser", auth.currentUser);
      })
      .then(() => {
        return commit("SET_SIGNING_IN", false);
      })
      .catch((error) => {
        let notification;
        if (error.code === "auth/email-already-in-use") {
          notification = {
            title: "That email is already in use",
            message: "Would you like to sign in with that email?",
            type: "error",
            icon: "person",
            timeout: 7000,
            actions: [{ route: "/sign-in", text: "Sign in" }],
          };
        } else {
          notification = {
            title: "Couldn’t create your account",
            message: "Please check your wifi and try again",
            type: "error-important",
            icon: "wifi-off",
          };
        }

        dispatch("fireNotification", notification);
        commit("SET_SIGNING_IN", false);
      });
  },
  signInWithPassword({ dispatch, commit }, credentials) {
    commit("SET_SIGNING_IN", true);
    return auth
      .signInWithEmailAndPassword(credentials.email, credentials.password)
      .then(() => {
        const user = auth.currentUser;

        return dispatch("getData", user).then(() => {
          return commit("SET_SIGNING_IN", false);
        });
      })
      .catch(function(error) {
        if (error.code === "auth/user-not-found")
          dispatch("fireNotification", {
            title: "Email or password is incorrect",
            message: "New user? Try signing up",
            type: "error-important",
          });
        else
          dispatch("fireNotification", {
            title: "Couldn’t log you in",
            message: "Please check your wifi and try again",
            type: "error-important",
            icon: "wifi-off",
          });
        return commit("SET_SIGNING_IN", false);
      });
  },
  sendPasswordResetEmail({ dispatch }, email) {
    const payload = {
      email: email,
    };

    return functions
      .httpsCallable("sendPasswordResetEmail")(payload)
      .then(() => "done")
      .catch(() => {
        return dispatch("fireNotification", {
          title: "We couldn’t send the email",
          text: "Please check your wifi and try again",
          type: "error",
        });
      });
  },
  setNewPassword({ dispatch }, payload) {
    return auth
      .signInWithCustomToken(payload.token)
      .then(() => {
        auth.currentUser
          .updatePassword(payload.password)
          .then(function() {
            dispatch("fireNotification", {
              title: "Password updated!",
              type: "success",
            });
          })
          .catch(function(error) {
            dispatch("fireNotification", {
              title: "Couldn’t update your password",
              text: "But you are now logged in, so hey",
              type: "error",
            });
          });
      })
      .catch(function(error) {
        dispatch("fireNotification", {
          title: "We couldn’t log you in",
          text: "Please check your wifi and try again",
          type: "error",
        });
      });
  },
  signOut({ dispatch, commit }, redirect) {
    commit("SET_SIGNING_OUT", true);
    auth
      .signOut()
      .then(function() {
        commit("SET_SIGNING_OUT", false);
        dispatch("resetAppState");

        if (redirect) router.push("/sign-in");
      })
      .catch(() => {
        let notification = {
          title: "Couldn’t log out",
          message: "Please check your wifi and try again",
          type: "error-important",
          icon: "wifi-off",
        };
        dispatch("fireNotification", notification);
        commit("SET_SIGNING_OUT", false);
      });
  },
};

const getters = {
  isSigningIn: (state) => state.isSigningIn,
  isSigningOut: (state) => state.isSigningOut,
};

const usersModule = {
  state,
  mutations,
  actions,
  getters,
};

export default usersModule;
